import { Button, Input } from "antd";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import { showErrorNotification } from "../../../../utility/Helpers";

const AddCookingInstructionModal = ({ show, onClose, onLinkAdded, onInstructionAdded }) => {
  const language = useSelector((state) => state.language.lang);
  const [text, setText] = useState("");
  const [link, setLink] = useState("");

  useEffect(() => {
    setText("");
    setLink("");
  }, [show]);

  const addInstructionClicked = () => {
    if (!text.trim()) {
      return showErrorNotification(language["please-enter-instruction-text"] ?? "please-enter-instruction-text");
    }
    if (onInstructionAdded) {
      onInstructionAdded(text);
    }
  };

  const addLinkClicked = () => {
    if (!link.trim()) {
      return showErrorNotification(language["please-enter-link"] ?? "please-enter-link");
    }
    if (onLinkAdded) {
      onLinkAdded(link);
    }
  };

  return (
    <Modal
      backdrop="static"
      className="add-cooking-instruction-modal"
      show={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center">
          {language["add-step-by-step-cooking-instructions"] ?? "add-step-by-step-cooking-instructions"}
          <Button type="text" onClick={onClose}>
            <AiOutlineClose />
          </Button>
        </div>
        <Input.TextArea value={text} onChange={(e) => setText(e.target.value)} rows={6} />
        <div className="d-flex justify-content-end">
          <Button onClick={addInstructionClicked} type="primary">
            {language["add"] ?? "add"}
          </Button>
        </div>
        <p className="text-center">{language["or"] ?? "or"}</p>
        <div className="d-flex justify-content-between align-items-center">{language["add-video-link"] ?? "add-video-link"}</div>
        <Input.TextArea value={link} onChange={(e) => setLink(e.target.value)} rows={6} />
        <div className="d-flex justify-content-end">
          <Button onClick={addLinkClicked} type="primary">
            {language["add"] ?? "add"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddCookingInstructionModal;
